export default "__VITE_ASSET__f4cf68de__"